import * as React from 'react'
import { getTimeZoneOptions } from './TimeZones'
import YumSelect, { YumSelectProps } from '../YumSelect/YumSelect'
import { t } from 'ttag'

import { ReactComponent as TimeZoneActiveIcon } from '../../assets/v3/icons/time-zone-active.svg'
import { ReactComponent as TimeZoneInactiveIcon } from '../../assets/v3/icons/time-zone-inactive.svg'
import Autocomplete from '@material-ui/lab/Autocomplete'
import YumField from '../YumInput/YumInput'

export interface YumTimeZoneSelectProps extends YumSelectProps {
  useAutocompleteSelect?: boolean
}

export interface YumTimeZoneSelectOption {
  label: string
  value: any
  offset: string
}

const YumTimeZoneSelect: React.FC<YumTimeZoneSelectProps> = (props) => {
  const { useAutocompleteSelect, value, ...otherProps } = props
  const options: YumTimeZoneSelectOption[] = React.useMemo(() => getTimeZoneOptions(), [])
  // Accessible name for the input/combobox. Callers may rely on a separate
  // visible label, so default to a sensible name when none is supplied — a
  // timezone combobox/edit field without an accessible name fails WCAG 3.3.2.
  const accessibleLabel =
    (props.inputProps as any)?.['aria-label'] ||
    (typeof props.label === 'string' ? props.label : undefined) ||
    t`Time zone`
  return useAutocompleteSelect ? (
    <Autocomplete
      disableClearable
      clearText={t`Clear`}
      closeText={t`Close`}
      openText={t`Open`}
      noOptionsText={t`No options`}
      openOnFocus
      onChange={(event, newValue) => {
        // @ts-ignore
        props.onChange?.({ target: { value: newValue?.value } }, null)
      }}
      options={options}
      value={options.find((option) => option.value === value)}
      getOptionLabel={(option) => option.label}
      /*getOptionSelected={(option, value) => option.value === value}*/
      renderInput={(params) => (
        <YumField
          {...params}
          label={props.label}
          style={props.style}
          /*startIcon={TimeZoneActiveIcon}
          startIconInactive={TimeZoneInactiveIcon}*/
          startIcon={TimeZoneInactiveIcon}
          value={value}
          error={props.error}
          variant="filled"
          // Merge (don't replace) Autocomplete's input wiring, and guarantee the
          // text edit field has an accessible name even without a visible label.
          inputProps={{ ...params.inputProps, 'aria-label': accessibleLabel }}
          InputProps={{
            ...params.InputProps,
            disableUnderline: true,
            // This disables the browser autocomplete.
            autoComplete: 'new-password',
          }}
          fullWidth={true}
          type="text"
        />
      )}
    />
  ) : (
    // @ts-ignore
    <YumSelect
      /*startIcon={TimeZoneActiveIcon} startInactiveIcon={TimeZoneInactiveIcon}*/
      startIcon={TimeZoneInactiveIcon}
      value={value}
      {...otherProps}
    >
      {options.map((option: YumTimeZoneSelectOption, index) => (
        <option key={index} value={option.value}>
          {option.label}
        </option>
      ))}
    </YumSelect>
  )
}

export default YumTimeZoneSelect
